<div class="on-boarding-wrapper" [class.active]="this.opened" id="on-boarding-wrapper">
  <div class="container">
    <div class="row text-center">
      <div class="col-md-12">
        <h1 class="color-white">{{'ON_BOARDING.WELCOME' | translate}}</h1>
      </div>
    </div>
    <app-on-boarding-video></app-on-boarding-video>
    <div class="row justify-content-center">
      <button (click)="this.close()">{{'ON_BOARDING.SKIP' | translate }}</button>
    </div>
  </div>
</div>
